export default "__VITE_ASSET__shJnMxuD__"